import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ENUMS from '../../../enums/index';
import { enumHelper } from '../../../utils';
import * as cafesActions from '../../../redux/cafes/actions';
import generateClassName from './../../../utils/generateClassName';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

import './styles.scss';

class CafesTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alertFlag: false,
      sortedColumn: ''
    };
  }

  convertCafeStatusToCssClass = status => {
    switch (status) {
      case ENUMS.CAFE_STATUS.values.REQUESTED:
        return 'text-warning';
      case ENUMS.CAFE_STATUS.values.CONFIRMED:
        return 'text-success';
      case ENUMS.CAFE_STATUS.values.PENDING:
        return 'text-info';
      default:
        return 'text-muted';
    }
  };

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };

  activateCafe = id => {
    this.props.changeCafeStatus(id, ENUMS.CAFE_STATUS.values.CONFIRMED).then(() => {
      AlertAndConfirmation({
        title: locales('titles.activision'),
        text: locales('titles.activatedSuccessfully'),
        type: 'success'
      });
    });
  };

  disableCafe = id => {
    this.props.changeCafeStatus(id, ENUMS.CAFE_STATUS.values.DISABLED).then(() => {
      AlertAndConfirmation({
        title: locales('titles.deactivision'),
        text: locales('titles.deactivatedSuccessfully'),
        type: 'success'
      });
    });
  };

  render() {
    let { cafes = [], pageNumber, pageSize, sortType } = this.props;

    return (
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="text-center">{locales('tables.row')}</th>
            <th onClick={() => this.sortTable('name')} className="text-center pointer">
              <i name="name" className={generateClassName('name', this.state.sortedColumn, sortType)} />
              {locales('tables.financial.transaction.userFullName')}
            </th>
            <th onClick={() => this.sortTable('cafeManagerName')} className="text-center pointer">
              <i
                name="cafeManagerName"
                className={generateClassName('cafeManagerName', this.state.sortedColumn, sortType)}
              />
              {locales('tables.cafeManagerName')}
            </th>
            <th onClick={() => this.sortTable('address')} className="text-center pointer">
              <i
                name="address"
                className={generateClassName('address', this.state.sortedColumn, sortType)}
              />
              {locales('messages.address')}
            </th>
            <th onClick={() => this.sortTable('createdAt')} className="text-center pointer">
              <i
                name="createdAt"
                className={generateClassName('createdAt', this.state.sortedColumn, sortType)}
              />
              {locales('fields.createdAt')}
            </th>
            <th onClick={() => this.sortTable('score')} className="text-center pointer">
              <i name="score" className={generateClassName('score', this.state.sortedColumn, sortType)} />
              {locales('labels.score')}
            </th>
            <th className="text-center">{locales('titles.discount')}</th>
            <th className="text-center">{locales('titles.event')}</th>
            <th className="text-center">{locales('titles.best')}</th>
            <th className="text-center">
              <i name="status" className={generateClassName('status', this.state.sortedColumn, sortType)} />
              {locales('fields.cafe.status')}
            </th>
            <th className="text-center" colSpan="4"></th>
          </tr>
        </thead>
        <tbody>
          {cafes.length ? (
            cafes.map((cafe, index) => (
              <tr key={cafe.id}>
                <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                <td className="text-center font-weight-bold">
                  {cafe.name.replace(locales('titles.cafe'), '')}
                </td>
                <td className="text-center">{cafe.ownerFullName}</td>
                <td className="text-center">{(cafe.address && cafe.address.split('،')[0]) || '---'}</td>
                <td className="text-center">{cafe.createdAt}</td>
                <td className="text-center">{cafe.score}</td>
                <td className="text-center">
                  <i
                    className={
                      cafe.hasDiscount
                        ? 'fal fa-vote-yea mx-1 text-success'
                        : 'fal fa-vote-nay mx-1 text-danger'
                    }
                  />
                </td>
                <td className="text-center">
                  <i
                    className={
                      cafe.hasEvent
                        ? 'fal fa-vote-yea mx-1 text-success'
                        : 'fal fa-vote-nay mx-1 text-danger'
                    }
                  />
                </td>
                <td className="text-center">
                  <i
                    className={
                      cafe.isBest ? 'fal fa-vote-yea mx-1 text-success' : 'fal fa-vote-nay mx-1 text-danger'
                    }
                  />
                </td>
                <td className="text-center font-weight-bold">
                  <span className={this.convertCafeStatusToCssClass(cafe.status)}>
                    {enumHelper.convertEnumValueToTitle(ENUMS.CAFE_STATUS.list, cafe.status)}
                  </span>
                </td>
                <td>
                  {(cafe.status === ENUMS.CAFE_STATUS.values.DISABLED ||
                    cafe.status === ENUMS.CAFE_STATUS.values.PENDING) && (
                    <a
                      onClick={e => {
                        e.preventDefault();
                        this.activateCafe(cafe.id);
                      }}
                      href="#"
                      className="btn btn-success btn-sm"
                    >
                      {locales('labels.activate.cafe')}
                    </a>
                  )}
                  {cafe.status === ENUMS.CAFE_STATUS.values.CONFIRMED && (
                    <a
                      onClick={e => {
                        e.preventDefault();
                        this.disableCafe(cafe.id);
                      }}
                      href="#"
                      className="btn btn-danger btn-sm"
                    >
                      {locales('labels.disable.cafe')}
                    </a>
                  )}
                </td>
                <td className="text-center">
                  <NavLink
                    to={{
                      cafeName: cafe.name,
                      pathname: '/cafes/users',
                      cafeId: cafe.id
                    }}
                  >
                    <i className="far fa-users font-xlarge mx-1 text-info" />
                  </NavLink>
                </td>
                <td title={locales('titles.editCafe')} className="text-center">
                  <NavLink
                    to={{
                      pathname: '/cafes/edit',
                      cafeId: cafe.id
                    }}
                  >
                    <i className="font-xlarge mx-1 text-success far fa-pen-square" />
                  </NavLink>
                </td>
              </tr>
            ))
          ) : (
            <tr className="col-12 text-center">
              <td className="alert alert-info" colSpan={12}>
                {locales('alerts.noRecord')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCafes: query => dispatch(cafesActions.getCafes(query)),
    changeCafeStatus: (cafeId, status) => dispatch(cafesActions.changeCafeStatus(cafeId, status))
  };
};

const mapStateToProps = state => {
  return {
    loading: state.cafesReducer.getCafesLoading,
    fail: state.cafesReducer.getCafesFailed,
    error: state.cafesReducer.getCafesError,
    message: state.cafesReducer.getCafesMessage,
    cafes: state.cafesReducer.cafes,
    cafe: state.cafesReducer.cafe
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CafesTable)
);
